/* import __COLOCATED_TEMPLATE__ from './send-app-with-introduction.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();